import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	PanelRow,
	RadioControl,
	ToolbarGroup,
} from '@wordpress/components';
import {
	BlockControls,
	AlignmentControl,
	store as blockEditorStore,
} from '@wordpress/block-editor';
import { positionLeft, positionRight, positionCenter } from '@wordpress/icons';
import { useSelect } from '@wordpress/data';
import { useEffect } from '@wordpress/element';

const DEFAULT_ALIGNMENT_CONTROLS = [
	{
		icon: positionLeft,
		title: __( 'Align left' ),
		align: 'left',
	},
	{
		icon: positionCenter,
		title: __( 'Align center' ),
		align: 'center',
	},
	{
		icon: positionRight,
		title: __( 'Align right' ),
		align: 'right',
	},
];

const Settings = ( props ) => {
	const {
		attributes: { position, isIcon, align },
		setAttributes,
	} = props;

	const options = [
		{ label: __( 'Inside', 'popper' ), value: 'inside' },
		{ label: __( 'Outside', 'popper' ), value: 'outside' },
		{ label: __( 'Corner', 'popper' ), value: 'corner' },
	];

	return (
		<>
			<BlockControls>
				{ 'outside' === position && (
					<ToolbarGroup>
						<AlignmentControl
							alignmentControls={ DEFAULT_ALIGNMENT_CONTROLS }
							value={ align || 'right' }
							onChange={ ( val ) => {
								setAttributes( { align: val } );
							} }
						/>
					</ToolbarGroup>
				) }
			</BlockControls>
			<PanelBody title={ __( 'Settings', 'popper' ) }>
				<PanelRow>
					<RadioControl
						label={ __( 'Button position', 'popper' ) }
						onChange={ ( val ) =>
							setAttributes( { position: val } )
						}
						selected={ position }
						options={ options }
					/>
				</PanelRow>
				<PanelRow>
					<RadioControl
						label={ __( 'Button type', 'popper' ) }
						onChange={ () => {
							setAttributes( { isIcon: ! isIcon } );
						} }
						selected={ isIcon }
						options={ [
							{ label: __( 'Icon', 'popper' ), value: true },
							{ label: __( 'Text', 'popper' ), value: false },
						] }
					/>
				</PanelRow>
			</PanelBody>
		</>
	);
};

export default Settings;
